<template>
  <sticky-tabs-bar class="sticky-tabs-bar z-10 sticky" :tabs="tabs" @tab-change="handleTabClick" />
</template>

<script setup lang="ts">
import StickyTabsBar from '@/components/common/sticky-tabs-bar.vue'

const { t } = useI18n()

const router = useLocaleRouter()

const props = defineProps<{
  pages: { key: string; title: string }[]
}>()

const tabs = computed(() => props.pages.map(page => ({ key: page.key, label: t(page.title) })))

const handleTabClick = (key: string) => {
  router.push({ path: `/${key}` })
}
</script>
